import React, { Component, PropTypes } from 'react';
import { Dialog } from 'material-ui';
import s3functions from '../../../utils/s3Upload';
import ReactDom from 'react-dom';
import Cropper from './image-crop';
import R from 'ramda';

class ImageCropDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cropperOpen: false,
      img: '',
      croppedImg: '',
    };
  }

  handleFileChange = dataURI => {
    this.setState({
      img: dataURI,
      croppedImg: this.state.croppedImg,
      cropperOpen: true,
    });
  };
  handleCrop = dataURI => {
    this.setState({
      cropperOpen: false,
      img: null,
      croppedImg: dataURI,
    });
    if (typeof this.props.uploadStartFn === 'function') this.props.uploadStartFn();
    // upload to s3
    const file = s3functions.dataURItoBlob(dataURI);
    const _this = this;
    s3functions.s3upload({
      file_to_upload: file,
      file_name: this.props.imageName,
      onProgress(percent) {
        if (percent === 100) return;
      },
      onFinishS3Put(publicUrl) {
        _this.props.confirmCroppedFn(publicUrl);
      },
      onError(status) {
        console.log(status);
      },
    });
  };
  handleRequestHide = () => {
    this.setState({
      cropperOpen: false,
    });
  };
  handleFile = (e) => {
    const reader = new FileReader();
    const file = e.target.files[0];
    if (!file) return;
    reader.onload = function(img) {
      ReactDom.findDOMNode(this.refs.in).value = '';
      this.handleFileChange(img.target.result);
    }.bind(this);
    reader.readAsDataURL(file);
  };
  render() {
    const setDialogWidth = R.call(R.cond([
      [R.equals('1200px'), R.always('90%')], // supplier cover photo
      [R.equals('800px'), R.always('75%')], // contractor cover photo
      [R.equals('400px'), R.always('35%')], // circular logo
      [R.T, R.always(this.props.dialogWidth)],
    ]), this.props.dialogWidth);

    return (
      <div>
        <input ref="in" style={{
          position: 'absolute',
          top: '0',
          cursor: 'pointer',
          bottom: '0',
          right: '0',
          opacity: '0',
          zIndex: this.props.style ? this.props.style.zIndex : '1',
        }} type="file" accept="image/*" onChange={this.handleFile}
        />
        {this.props.children}
        {
          this.state.cropperOpen ? (
            <Dialog
              modal
              open={this.state.cropperOpen}
              onRequestClose={this.handleRequestHide}
              contentStyle={{ width: '100%', maxWidth: setDialogWidth }}
              autoScrollBodyContent
            >
              <Cropper
                onRequestHide={this.handleRequestHide}
                onCrop={this.handleCrop}
                image={this.state.img}
                width={this.props.cropWidth}
                height={this.props.cropHeight}
                round={this.props.round}
              />
            </Dialog>
          ) : <span/>
        }
    </div>
    );
  }
}

ImageCropDialog.propTypes = {
  imageName: PropTypes.string.isRequired,
  cropWidth: PropTypes.number,
  cropHeight: PropTypes.number,
  dialogWidth: PropTypes.string,
  children: PropTypes.any,
  confirmCroppedFn: PropTypes.func.isRequired,
  uploadStartFn: PropTypes.func,
  style: PropTypes.object,
  round: PropTypes.bool,
};

export default ImageCropDialog;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/image-crop/image-crop-dialog.js